import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import * as downloadServiceSharedComponent from '@bingads-webui/download-service';

import { InlineDownloadReportDataRepository } from './inline-download-report-data-repository';

const asyncScheduler = globalContext.require('module/service/shared/asyncScheduler');
const cacheManager = globalContext.requireDefault('campaignui/feature/cache-manager/index');
const { getODataErrors } = globalContext.require('component/api-errors-campaign/index');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!@bingads-webui-campaign/inline-download-report-data-repository');
const odata = globalContext.require('component/http/channel/odata');
const pageContext = globalContext.require('PageContext');

/**
 * Creates a new instance of InlineDownloadReportDataRepository based on legacy dependencies
 * imported via the injection-context.
 * @param {Object} options - Additional options to be passed to constructor.
 * @returns {InlineDownloadReportDataRepository} New instance of repository.
 */
export function createInlineDownloadReportDataRepository(options) {
  const alertCenter = options.alertCenter || window.App.views.alertCenter;
  const downloadService = options.downloadService || downloadServiceSharedComponent;

  const deps = {
    alertCenter,
    asyncScheduler,
    cacheManager,
    downloadService,
    getODataErrors,
    i18n,
    odata,
    pageContext,
  };

  return new InlineDownloadReportDataRepository(_.extend({ deps }, options));
}
